var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"side-nav-container"},_vm._l((_vm.navItems),function(item){return (!_vm.loggedInUser.termsAndConditionsUpdateNeeded)?_c('side-nav-item',{key:item.label,attrs:{"nestingLevel":0,"item":item}}):_vm._e()}),1)}
var staticRenderFns = []

export { render, staticRenderFns }